import React from 'react';
import { Link } from 'react-router-dom';

interface AgreementModalProps {
  show: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export const AgreementModal: React.FC<AgreementModalProps> = ({
  show,
  onClose,
  onConfirm,
}) => {
  if (!show) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm p-4 animate-[fadeIn_0.15s_ease-out]">
      <div className="w-full max-w-sm bg-white rounded-2xl p-6 shadow-xl border border-background-200 text-center animate-[scaleUp_0.15s_ease-out]">
        <div className="w-12 h-12 rounded-2xl bg-primary-100 text-primary-600 flex items-center justify-center mx-auto mb-4">
          <i className="ri-file-shield-2-line text-2xl"></i>
        </div>
        <h3 className="text-base font-bold text-foreground-950 mb-2">服务条款及隐私政策</h3>
        <p className="text-xs text-foreground-500 leading-relaxed mb-6">
          为了保障您的合法权益，请先阅读并同意
          <Link to="/terms" target="_blank" className="text-primary-600 hover:underline mx-0.5">《服务条款》</Link>
          与
          <Link to="/privacy" target="_blank" className="text-primary-600 hover:underline ml-0.5">《隐私政策》</Link>
        </p>
        <div className="flex items-center gap-3">
          <button
            type="button"
            onClick={onClose}
            className="flex-1 py-2.5 rounded-xl border border-background-300 text-foreground-600 text-xs font-medium hover:bg-gray-50 transition-all cursor-pointer"
          >
            取消
          </button>
          <button
            type="button"
            onClick={onConfirm}
            className="flex-1 py-2.5 rounded-xl bg-primary-500 text-foreground-950 text-xs font-semibold hover:bg-primary-400 shadow-sm transition-all cursor-pointer"
          >
            同意并继续
          </button>
        </div>
      </div>
    </div>
  );
};
